import swal from 'sweetalert'
import 'sweetalert/dist/sweetalert.css';
import jQuery from 'jquery';

import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import * as FormActions from '../actions'

import EventBanner from '../../components/event_banner';
import EventCategoryContainer from '../../components/event_category_container';
import EventFeeContainer from '../../components/event_fee_container';
import EventFormFieldsContainer from '../../components/event_form_fields_container';
import EventFormAccommodationContainer from '../../components/event_form_accommodation_container';
import EventFormPaymentContainer from '../../components/event_form_payment_container';
import EventFormSummary from '../../components/event_form_summary';
import EventThankyou from '../../components/event_thankyou';

var EventRender = React.createClass({
  validateForm: function(data) {
    let errors = [];

    // category
    if (!data.form.category) {
      errors.push('Please select a registration category.');
    }


    // console.log(this.props.fields);
    // console.log(data.form);
    // console.log(data.form.hasOwnProperty("radiotest"));



    // form fields
    const missing_fields = [];
    // const missing_fields = this.props.fields.filter( (f) => f.required && !data.form.hasOwnProperty(f.name)).map( (f) => 'The '+f.label+' field is required.');
    // const missing_fields = this.props.fields.filter( (f) => f.required && !data.form.hasOwnProperty(f.name) && !(f.field_type == 'checkbox' || f.field_type == 'radio')).map( (f) => 'The '+f.label+' field is required.');


    $(this.props.fields).each(function( index ) {
      let field = $(this)[0];
      console.log(field.name);

      if(field.required) {
        switch(field.field_type) {
          case 'radio':
          case 'checkbox':
            if(!$("input[name='"+field.name+"']:checked").val()) {
              missing_fields.push('The '+field.label+' field is required.');
            }
            break;
          case 'text':
          case 'email':
            if(!$("input[name='"+field.name+"']").val()) {
              missing_fields.push('The '+field.label+' field is required.');
            }
            break;
          case 'dropdown':
            if(!$("select[name='"+field.name+"']").val()) {
              missing_fields.push('The '+field.label+' field is required.');
            }
            break;
          default:
            // code block
        }
      }
    });


    errors = errors.concat(missing_fields);

    // console.log(missing_fields);

    // fees
    if (Object.keys(data.form.fees).length === 0) {
      errors.push('Please register for at least one item.');
    }

    // accommodation
    if (data.accommodation.required) {
      const missing_accommodation_fields = [{ name: 'occupancy', label: 'Hotel Occupancy' }, { name: 'checkin_date', label: 'Check-in date' }, { name: 'checkout_date', label: 'Checkout date'}].filter( (f) => !data.accommodation.hasOwnProperty(f.name) ).map( (f) => 'The '+f.label+' field is required.');
      errors = errors.concat(missing_accommodation_fields);
    }

    // payment
    if (data.form.total > 0 && !data.payment_details.payment_method) {
      errors.push('Please select a payment method.');
    }
    if (data.form.total > 0 && data.payment_details.payment_method == 'credit_card') {
      // CVC intentionally omitted
      const missing_payment_fields = [{ name: 'name', label: 'Credit Card Name' }, { name: 'number', label: 'Credit Card Number' }, { name: 'exp_month', label: 'Credit Card Expiry Month'}, { name: 'exp_year', label: 'Credit Card Expiry Year'}].filter( (f) => !data.payment_details.hasOwnProperty(f.name) ).map( (f) => 'The '+f.label+' field is required.');
      errors = errors.concat(missing_payment_fields);
    }

    return errors.length == 0 ? false : errors;
  },
  onSubmit: function(e) {
    e.preventDefault();
    const val_data = { form: this.props.form, accommodation: this.props.accommodation, payment_details: this.props.payment_details };
    let valErrors = this.validateForm(val_data);
    if (valErrors) {
      return swal({
        title: 'Error',
        text: 'Please correct the following errors: <div class="well">'+valErrors.join('<br />')+'</ul></div>',
        type: 'error',
        html: true
      })
    }

    var submit_data = {
      record_id: this.props.form.record_id,
      record_type: this.props.form.record_type,
      category: this.props.form.category,
      fees: this.props.fees.filter( f => f.qty > 0 ),
      completed_form: this.props.fields.reduce(function(o, v, i) {



        if (v.field_type == 'radio') {
          //get checked value of radio
          let checked_radio_value = '';
          if($("input[name='"+v.name+"']:checked").val()) {
            checked_radio_value = $("input[name='"+v.name+"']:checked").val();
          }

          o[v.name] = checked_radio_value;

        }
        else if (v.field_type == 'checkbox') {
          //get checked value of radio
          let checkbox_values = [];

          checkbox_values = $("input[name='"+v.name+"']:checked").map(function(){
            return $(this).val();
          }).get();

          o[v.name] = checkbox_values;
          
        }
        else if (v.field_type != 'display') {
          o[v.name] = v.value;
        }
        return o;
      }, {}),
      accommodation: this.props.accommodation,
      subtotal: this.props.form.subtotal,
      tax_name: this.props.form.tax_name,
      tax_rate: this.props.form.tax_rate,
      tax: this.props.form.tax,
      total: this.props.form.total,
      complimentary: this.props.form.complimentary,
      payment_method: this.props.payment_details.payment_method
    }

    // console.dir(submit_data);
    // console.dir(this.props.fields);

    // attempt Stripe charge
    if (this.props.payment_details.payment_method == 'credit_card') {
      swal({
        title: 'Please wait...',
        text: 'Your credit card is being charged.',
        type: 'info',
        showCancelButton: false,
        showConfirmButton: false,
        closeOnConfirm: false
      });

      const charge = {
        name: this.props.payment_details.name,
        number: this.props.payment_details.number,
        exp_month: this.props.payment_details.exp_month,
        exp_year: this.props.payment_details.exp_year,
        cvc: this.props.payment_details.cvc
      };
      Stripe.card.createToken(charge, (status, response) => {
        if (response.error) {
          return swal({
            title: 'Error',
            text: response.error.message,
            type: 'error'
          });
        } else {
          submit_data.stripe_token = response.id;
          this.finalSubmit(submit_data);
        }
      });
    } else {
      // cheque
      this.finalSubmit(submit_data);
    }
  },
  finalSubmit: function(submit_data) {
    // FINAL SUBMIT
    swal({
      title: 'Finalizing order...',
      text: 'Now finalizing your order...',
      type: 'info',
      showCancelButton: false,
      showConfirmButton: false,
      closeOnConfirm: false
    });

    $.ajax({
      url: window.location.href,
      type: 'POST',
      data: submit_data,
      dataType: 'json'
    })
    .done(( data, textStatus, jqXHR ) => {
      swal.close();
      this.props.actions.finalizeSubmission();
    })
    .fail(( jqXHR, textStatus ) => {
      var response = $.parseJSON(jqXHR.responseText);
      return swal({
        title: 'Error',
        text: response.error,
        type: 'error'
      })
    });
  },
  render: function() {
    const { active, admin, expired, form, actions, selected_category, banner_image, categories, fees, fields, accommodation, payment_details } = this.props;

    if (!active || expired) {
      if (this.props.closed_message) {
        return (
          <div className="container">
            <EventBanner src={ banner_image } />
            <EventThankyou message={this.props.closed_message} continueUrl="http://www.cci.ca" />
          </div>
        );
      }
      else {
        return (
          <div className="container">
            <EventBanner src={ banner_image } />
            <EventThankyou message="Online registration is now closed." continueUrl="http://www.cci.ca" />
          </div>
        );
      }
    }

    if (form.finalized) {
      return (
        <div className="container">
          <EventBanner src={ banner_image } />
          <EventThankyou message={selected_category.thank_you_message } continueUrl={selected_category.continue_url} />
        </div>
      );
    }

    return (
      <form action={window.location.href} method="POST" className="form-horizontal" onSubmit={this.onSubmit}>
        <div className="container">
          <EventBanner src={ banner_image } />
          <div className="row">
            <div className="col-sm-offset-2 col-sm-8">
              <EventCategoryContainer categories={categories} onChange={actions.updateForm} />
            </div>
          </div>
          { !form.category ? undefined :
          <div>
            <div className="row">
              <div className="col-sm-offset-2 col-sm-8">
                <EventFormFieldsContainer onChange={actions.updateForm} onValidateEmail={actions.finalizeLogin} fields={fields} validatedMembership={form.validated_membership} />
              </div>
            </div>
            <div className="row">
              <div className="col-sm-offset-2 col-sm-8">
                <EventFeeContainer is_front_end={true} admin={admin} fees={fees} onIncreaseFeeQty={actions.increaseFeeQty} onDecreaseFeeQty={actions.decreaseFeeQty} />
              </div>
            </div>
            { selected_category.accommodation_enabled ?
            <div className="row">
              <div className="col-sm-offset-2 col-sm-8">
                <EventFormAccommodationContainer accommodation={accommodation} onChange={actions.updateAccommodationDetails} />
              </div>
            </div>
            : undefined }
            { form.total > 0 || form.complimentary ?
            <div className="row">
              <div className="col-sm-offset-2 col-sm-8">
                <EventFormPaymentContainer admin={admin} onComplimentaryChange={actions.changeComplimentary} onChange={actions.updatePaymentDetails} subtotal={form.subtotal} allow_cheque={form.allow_cheque} tax_name={form.tax_name} tax={form.tax} total={form.total} complimentary={form.complimentary} {...payment_details} />
              </div>
            </div>
            : undefined }
            <div className="row">
              <div className="col-sm-offset-2 col-sm-8">
                <div className="panel">
                  <div className="panel-body text-right">
                    <button className="btn btn-primary btn-gradient btn-lg" type="submit">Submit</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          }
        </div>
      </form>
    );
  }
});

function mapStateToProps(state, ownProps) {
  // logic to merge state for the fees and fields into display props
  let categories = ownProps.categories.filter( (c) =>
    !c.admin || (c.admin && state.admin.isAdmin)
  );
  let selected_category = categories.find( (c) =>
    c.name == state.form.category
  );
  let fees = !selected_category ? undefined :
    selected_category.fees.filter( (f) =>
      f.enabled && (!f.admin || (f.admin && state.admin.isAdmin)) // fee is enabled and if for admin's only, this is an admin
    ).map( (f) =>
      state.form.fees && state.form.fees[f.name] ?
        Object.assign(f, state.form.fees[f.name]) :
        Object.assign(f, { qty: 0, price: f.price })
  );
  let fields = ownProps.fields.map( (f) =>
    Object.assign(f, { value: (state.form[f.name] ? state.form[f.name] : '') })
  );

  return {
    admin: state.admin,
    form: state.form,
    accommodation: state.accommodation,
    payment_details: state.payment_details,
    selected_category: selected_category,
    categories: categories,
    fees: fees,
    fields: fields
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(FormActions, dispatch)
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EventRender)


// WEBPACK FOOTER //
// ./src/event_render/containers/event_render.js